// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CalendarIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CalendarIcon" ref={forwardedRef} {...props}>
      <path d="M5 9h1.5v1.5H5z" />
      <path d="M5 11.998h1.5v1.5H5z" />
      <path d="M10.75 9h-1.5v1.5h1.5z" />
      <path d="M9.25 11.998h1.5v1.5h-1.5z" />
      <path d="M15 9h-1.5v1.5H15z" />
      <path d="M13.5 11.998H15v1.5h-1.5z" />
      <path d="M6.5 2.746V4h7V2.746H15V4h2a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h2V2.746zm0 2.754v1.246H5V5.5H3.5v10h13v-10H15v1.246h-1.5V5.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CalendarIcon = /* @__PURE__ */ Object.assign(
  CalendarIconComponent,
  { displayName: 'CalendarIcon' },
);
